import { Entity } from '../../../../../types';

export function isIntegrationEntity(entity: Entity): boolean {
  return (
    entity.properties._integrationDefinitionId !== null &&
    entity.properties._integrationDefinitionId !== undefined
  );
}
